
import React, { useEffect, useState } from "react";

import styles from "./scss/chattopics.module.scss";
import Toprightside from "./chattoprightside";
import Topleftside from "./chattopleftside";
import ChatProgressBar from "../chatWidgets/chatProgressBar";
import { chats, chatwindowDetails, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import Deleteconfirmsec from "./deleteconfirmsec";
import { Tooltip } from "antd";
import { URInputwithLabel } from "../../../shared/widgets/inputwithLable";
import store from "../../../context/store/store";
import { Types } from "../../../context/action/action";
import ChatFileComplete from "../chatWidgets/chatProgressBar/completeToast";
import _ from "lodash";

type  chatTopState = {
  showSearch:boolean;
  updownCount:number;
  totalCount:number;
}

export default function ChatTopics() {
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const chatSocket = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  const [topInfo, settopInfo] = useState<chatTopState>({ showSearch:false,updownCount:0,totalCount:0
  });

  const openSearch= ()=>{
    settopInfo({...topInfo,
      showSearch:!topInfo.showSearch});
    store.dispatch({
      type: Types.CHAT_SEARCH_STORE,
      payload: {
        isSearch: true
      }
    });
  };
  useEffect(()=>{
    const input: any = document.getElementById("inputBox");
  if (input !== null) {
    console.log(input,"input")
    input.focus();
  }
  },[chatReducer.isSearch])

  useEffect(()=>{
    var focusableInputElements:any = document.querySelectorAll(".tranText");
    settopInfo({...topInfo ,
      totalCount:focusableInputElements.length,updownCount:0});
      if(focusableInputElements?.length > 0){
        debounce_fun();
      }
     
  },[chatReducer.searchData,chatWindow]);
  var debounce_fun = _.debounce(function () {
    var focusableInputElements:any = document.querySelectorAll(".tranText");
    if(focusableInputElements?.length > 0){
    focusableInputElements[0].focus();
        focusableInputElements[0].style.backgroundColor = "#B3D7FA";
        focusableInputElements[0].style.borderBottom = "1px solid #68AFF5";
        var inn:any = document.getElementById('inputBox')
        inn?.focus();
    }
    console.log('Function debounced after 1000ms!');
    }, 1000);
  const closeSearch=()=>{
    settopInfo({...topInfo,
      showSearch:!topInfo.showSearch});
    store.dispatch({
      type: Types.CHAT_SEARCH_STORE,
      payload: {
        searchData: "",
        isSearch: false
      }
    });
  };

  const searchInput = (e:any)=>{
    store.dispatch({
      type: Types.CHAT_SEARCH_STORE,
      payload: {
        searchData: e.trim(),
        isSearch: true
      }
    });
  };

  const downArrow = (e:any)=>{
    let downCountRes:number = topInfo.updownCount + 1;
    if(downCountRes < topInfo.totalCount){
      var focusableInputElements:any = document.querySelectorAll(".tranText");
      let nextIndex = downCountRes;
      e.preventDefault();
      nextIndex= downCountRes;
      focusableInputElements[nextIndex].focus();
      focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
      focusableInputElements[nextIndex].style.borderBottom = "1px solid #68AFF5";
      focusableInputElements[nextIndex - 1].style.backgroundColor = "#FBF4C5";
      focusableInputElements[nextIndex - 1].style.borderBottom = "1px solid #FBE880";
      settopInfo({...topInfo ,
        updownCount:downCountRes});
    }
  };


  const upArrow = (e:any)=>{
    let downCountRes:number = topInfo.updownCount - 1;
    if(topInfo.updownCount !== 0){
      var focusableInputElements:any = document.querySelectorAll(".tranText");
      let nextIndex = downCountRes;
      e.preventDefault();
      nextIndex= downCountRes;
      focusableInputElements[nextIndex].focus();
      focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
      focusableInputElements[nextIndex].style.borderBottom = "1px solid #68AFF5";
      focusableInputElements[nextIndex + 1].style.backgroundColor = "#FBF4C5";
      focusableInputElements[nextIndex + 1].style.borderBottom = "1px solid #FBE880";
      settopInfo({...topInfo ,
        updownCount:downCountRes});
    }
  };
 let name =  chatWindow.chatWindowDetails?.team_id ? chatWindow?.chatWindowDetails?.team_name:  chatWindow?.chatWindowDetails?.caller_id;
  return (
    <>

      {!chatReducer.isSearch &&<div className={styles.chattopic}>

        <Topleftside ></Topleftside> 

        {/* Need to handle */}
        {chatSocket.fileUploadingStatus && <ChatProgressBar />}
        {chatSocket.progressComplete && <ChatFileComplete/>}

        <div className={styles.rights}>
          {/* Need to handle */}
          { (chatReducer.isForward||chatReducer.isDelete || chatReducer.multiOption) && <Deleteconfirmsec />}

          {!chatWindow.isNewMessageWindow && !chatReducer.multiOption && 
          <Toprightside openSearch={openSearch}></Toprightside>}
        </div>
      </div>}




      {chatReducer.isSearch &&  
      <div className={styles.searchBoxlefts}>
        <div className={styles.lefts}>
          <Tooltip  mouseEnterDelay={0.5}  placement="top" title={'Search Chats'}>
            <span className="icon_zoom"></span>
          </Tooltip>
          <div className={chatReducer.isSearch ? styles.searchTextChat :`searchAlign ${styles.searchTextChat}`}>
            <URInputwithLabel placeHolder={"Search in "+ name}
              className="inputBox" id="inputBox"
              onChange={(e: React.FormEvent<HTMLInputElement>) => searchInput(e.currentTarget.value)}/>
          </div>
        </div>
        <div className={styles.rights}>
          <ul>
            {topInfo.totalCount !== 0 && <><p>  <span>{topInfo.updownCount + 1}</span>
              <span className={styles.ofText}>of</span><span>{topInfo.totalCount}</span></p><Tooltip title='Find previous' placement="top">
              <li className={styles.linkIcons}><span className="icon_searchlft" onClick={upArrow}></span></li>
            </Tooltip><Tooltip title='Find next' placement="top">
              <li className={styles.linkIcons}><span className="icon_searchrgt" onClick={downArrow}></span></li>
            </Tooltip></>}
            <li className={styles.linkIconsLine}><span></span></li>
            <li className={styles.linkIcons}><span className="icon_close" onClick={closeSearch}></span></li>
          </ul>
        </div>
      </div>
      }



    </>
  );
};

